// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6fb0086","667":"be56ad59","977":"33ee0076"}[chunkId] + ".chunk.js";
};